import { Component, OnInit } from '@angular/core';

import { PageClass } from '../../core/classes/page';
import { Activity } from '../../core/enums';

import { 
  ActivityFormatService, AgeGroupService, ArrayService, AuthService, 
  ChurchService, DatabaseService, FestivalUserService 
} from 'src/core/services';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent extends PageClass implements OnInit {

  activeRoute: string;

  isAdmin: boolean = false;
  isNotActiveCoordinator: boolean = false;

  canSeeMembers: boolean = false;
  canSeeSports: boolean = false
  canSeeActivities: boolean = false;
  canSeeFormats: boolean = false;
  canSeeChoir: boolean = false;
  canSeeIT: boolean = false;
  canSeeMedia: boolean = false;
  canSeeResearch: boolean = false;
  canSeeTheatre: boolean = false;
  canSeeVisualArt: boolean = false;
  canSeeReports: boolean = false;


  constructor(
    protected activityFormatService: ActivityFormatService,
    protected ageGroupService: AgeGroupService,
    protected arrayService: ArrayService,
    protected authService: AuthService,
    protected churchService: ChurchService,
    protected databaseService: DatabaseService,
    protected festivalUserService: FestivalUserService,
  ) { 
    super(ageGroupService, arrayService, authService, churchService, databaseService, festivalUserService);
  }

  protected loadData = async () => {

    const user = this.currentUser;
    this.isAdmin = user.isAdmin && !user.isReportViewer;
    this.isNotActiveCoordinator = !user.isActivityCoordinator && !user.isReportViewer;

    this.canSeeReports = user.isAdmin || user.isReportViewer;

    this.canSeeMembers = user.isAdmin || user.isMemberCoordinator;
    
    this.canSeeSports =  user.isAdmin || user.isChurchApprover || 
                         user.isSportCoordinator || user.isSportLeader;

    this.canSeeFormats = user.isAdmin || user.isActivityLeader;
    this.canSeeActivities = this.canSeeFormats || user.isActivityCoordinator || user.isActivityApprover;

    
    const activityList = this.activityFormatService.getActivityList();
    const choirActivity = activityList.find(a => a.value == Activity.Choir);
    const itActivity = activityList.find(a => a.value == Activity.IT);
    const mediaActivity = activityList.find(a => a.value == Activity.Media);
    const researchActivity = activityList.find(a => a.value == Activity.Research);
    const theatreActivity = activityList.find(a => a.value == Activity.Theatre);
    const visualArtActivity = activityList.find(a => a.value == Activity.VisualArts);

    this.canSeeChoir = user.isAdmin || 
                      (this.canSeeActivities && 
                       user.activityList?.findIndex(a => a.value === choirActivity.value) !== -1);
    
    this.canSeeIT = user.isAdmin || 
                      (this.canSeeActivities && 
                      user.activityList?.findIndex(a => a.value === itActivity.value) !== -1);

    this.canSeeMedia = user.isAdmin || 
                      (this.canSeeActivities && 
                      user.activityList?.findIndex(a => a.value === mediaActivity.value) !== -1);

    this.canSeeResearch = user.isAdmin || 
                      (this.canSeeActivities && 
                      user.activityList?.findIndex(a => a.value === researchActivity.value) !== -1);

    this.canSeeTheatre = user.isAdmin || 
                       (this.canSeeActivities && 
                        user.activityList?.findIndex(a => a.value === theatreActivity.value) !== -1);

    this.canSeeVisualArt = user.isAdmin || 
                        (this.canSeeActivities && 
                         user.activityList?.findIndex(a => a.value === visualArtActivity.value) !== -1);
  }

  public logoutUser() {
    this.authService.signOut();
  }
}
